export default "__VITE_ASSET__DCUAsooZ__"